import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import { MenuManagementService } from '../menu/services/menu-management.service';
import { CoordinatePoint, CoordinatePointModel } from '../models/coordinate-point';
import { ConfigurationConstants } from '../models/EnumTypes';
import { NavaidModel, NavAidsCSVContent } from '../models/navaid';
import { MapService } from './map.service';
import { ModalConfirmationService } from './modal-confirmation.service';
import { ModalControlService } from './modal-control.service';
import { PointsService } from './points.service';
import { ProjectService } from './project.service';
import { SearchService } from './search.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { EndpointsService } from './endpoints.service';
import { ErrorModel } from '../models/error';
import { NavaidStatus } from '../models/NavaidStatus';
import { NavaidStatusComponent } from '../popup/import/navaid-status/navaid-status.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { NavaidErrorModel } from '../models/NavaidErrorModel';
import * as fileSaver from 'file-saver';
import { UiBlockService } from './ui-block.service';
@Injectable({
  providedIn: 'root'
})
export class NavaidControlService {
  public active: boolean;
  public selectedNavaid: NavaidModel;
  public activeSectorizations:boolean = false;
  public activeAngles:boolean = false;


  public colapsableLabelSectorizations: boolean;
  public colapsableDivSectorizations: boolean;

  constructor(private projectService: ProjectService,
    private mapService : MapService,
    private menuService : MenuManagementService,
    private pointsController: PointsService,
    private modalControlService: ModalControlService,
    private confirmationModal : ModalConfirmationService,
    private http: HttpClient,
    private endpointService: EndpointsService,
    private modalService : BsModalService,
    private uiBlock: UiBlockService
    ) {

     }

  createNavaid(){
    if (this.projectService.projectEditable()){
      this.active = this.active? true : !this.active;
      this.selectedNavaid = new NavaidModel();
      this.selectedNavaid.navaidtype = "DME";
      this.selectedNavaid.cone= 50;
    }
    this.menuService.toogleMenu();
  }

  activeCreateNavAidWindow() {
    this.active = this.active? true : !this.active;

    this.selectedNavaid = new NavaidModel();
    this.selectedNavaid.navaidtype = "DME";
    this.selectedNavaid.cone= 50;

    this.menuService.toogleMenu();

  }
  createNavAidFromCSV(model : NavaidModel []) : void {
    if (!this.projectService.projectEditable()){
      return;
    }
    if(model.length > 0){
      this.confirmationModal.showMesssageConfirmationModal("Import navaids from CSV", "During the update Process: Fields present on CSV file and on GRIT Database will be overwritten and the information on GRIT Database will be updated. Fields missing on CSV file but present on GRIT Database will be preserved.", "OK", "Cancel", () => this.openStatusModal(model));
    }else {
       this.modalControlService.showMesssageModal("Create NavAid","Please select at least one NavAid to import.");
    }
  }

  openStatusModal(model : NavaidModel []) {

    let navaidsStatus : any = this.validateNavaids(model).subscribe(
      (response : NavaidErrorModel[]) => {
        const bsModalRef : BsModalRef = this.modalService.show(NavaidStatusComponent);
        bsModalRef.content.navaids = model;
        bsModalRef.content.navaidsStatus = this.convertErrorsToNavaidStatus(response);
      },
      (error) => {
        this.modalControlService.showMesssageModal("Error Importing Navaids", "Error importing navaids");
      }
    );
  }
  orderCSVNavAidList(navaids: NavaidModel[]) : NavaidModel [] {
    let navaidsToReturn: NavaidModel[] = Array<NavaidModel>();

    navaids.forEach(navaid => {
      if (navaid.dataType === 1) {
        navaidsToReturn.push(navaid);
      }
      else {
        const navIndex = navaidsToReturn.findIndex((nav => nav.navaidid === navaid.navaidid));

        if (navIndex != -1) {
          if (navaid.sectorizations.length > 0 ) {
            navaidsToReturn[navIndex].addSectorization(navaid.sectorizations[0]);
          }

          if (navaid.actualScreeningAngle.length > 0) {
            navaidsToReturn[navIndex].addMinimumScreeningAngle(navaid.actualScreeningAngle[0]);
          }
          if(navaid.navaidFiles != null && navaid.navaidFiles.length > 0){
            navaidsToReturn[navIndex].navaidFiles.push(navaid.navaidFiles[0]);
          }
        }
      }
    });

    return navaidsToReturn;
  }

  validateCoordPointDistance(coordPoint : CoordinatePointModel, dbCoordPoint: CoordinatePoint): boolean{
    const coords = {
      lat1: coordPoint.latitude,
      lng1: coordPoint.longitude,
      lat2: dbCoordPoint.latitude,
      lng2: dbCoordPoint.longitude
    };
    var res = 0//greatCircleDistance(coords) * 1000; //RESULT IN km -> m
    return res < ConfigurationConstants.COORDINATE_POINT_MAX_DISTANCE_METERS_SAME_ID;
  }

  public validateNavaids(navAidsList: NavaidModel[]) : Observable<Object> {
      return this.http
        .post(
          this.endpointService.endpointValidate,
          JSON.stringify(navAidsList),
          this.endpointService.jsonHttpOptions
        );
  }

  public getIcaoFromItuCode(itu_code : String) : Observable<Object> {
    return this.http
      .get(
        this.endpointService.endpointItuIcao + "/" + itu_code,
        this.endpointService.jsonHttpOptions
      );
  }

  convertErrorsToNavaidStatus(response : NavaidErrorModel[]) : NavaidStatus[] {
    let navaidsStatus : NavaidStatus[] = [];
    response.forEach (item => {

      if (item.code == "OK"){
        let status : NavaidStatus = new NavaidStatus(item.navaidid, item.name, item.type, item.code);
        navaidsStatus.push(status);
      }else {
        let status : NavaidStatus = new NavaidStatus(item.navaidid, item.name, item.type, item.message.split('- ', 2)[1]);
        navaidsStatus.push(status);
      }
    });

    return navaidsStatus;
  }
  getAllCSVNavaids(includeNavaidFiles:boolean){
    if (this.pointsController.getAllNavaidsFeaturesFromLayers().length == 0){
      this.modalControlService.showMesssageModal("Warning", "No available NavAids to export");
      return;
    }
    this.http.get<Blob>(this.endpointService.allNavaidsCSVUrl,
      {
        headers : this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
        params : {
          "ids" : null,
          "includeFiles": JSON.stringify(includeNavaidFiles)
        }
      },
    ).subscribe(
      (blob:Blob) => {
        fileSaver.saveAs(blob, "navaidFile.csv");
      },
      (error) => this.modalControlService.showMesssageModal("error","Error generating csv file")
    )
  }
  getSelectedCSVNavaids(includeNavaidFiles:boolean){
    let identifiers = "";
    for(const element of this.pointsController.getSelectedFeatures()) {
      if(element.getProperties().featureType == 0){//navaid
        identifiers += element.get("id") + ";";
      }
    }
    this.http.get<Blob>(this.endpointService.selectedNavaidsCSVUrl,
      {
        headers : this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
        params : {
          "ids" : identifiers,
          "includeFiles": JSON.stringify(includeNavaidFiles)
        }
      }).subscribe(
        (blob:Blob) => {
          fileSaver.saveAs(blob, "navaidFile.csv");
        },
        (error) => this.modalControlService.showMesssageModal("error","Error generating csv file")
      )
  }



  async editNavaid(){
    if (this.projectService.projectEditable()){
      if(this.pointsController.getSelectedFeatures().length>0){
        this.selectedNavaid = this.pointsController.transformFeatureInNavaid(this.pointsController.getSelectedFeatures()[0]);
        this.selectedNavaid.latLonDms.fromLat(this.selectedNavaid.latitude);
        this.selectedNavaid.latLonDms.fromLon(this.selectedNavaid.longitude);
        (await this.pointsController.getTerrainElevation(this.selectedNavaid.latitude, this.selectedNavaid.longitude)).subscribe(
          (data) => {
            this.selectedNavaid.elevationTerrainMeters = data;
            this.selectedNavaid.elevationTerrainFeet = this.pointsController.convertToFeet(data);

            this.selectedNavaid.elevationRelativeTerrainMeters = this.selectedNavaid.elevationTerrainMeters + this.selectedNavaid.antheightMeters;
            this.selectedNavaid.elevationRelativeTerrainFeet = this.selectedNavaid.elevationTerrainFeet + this.selectedNavaid.antheight;


            this.active = !this.active;
          }
        );
      }else {
        this.modalControlService.showMesssageModal("Warning", "Select at least 1 Navaid to edit.");
      }
    }
    this.menuService.toogleMenu();
  }

  exportNavaidsToSafireRequest(navaids: NavaidModel[]){
    this.uiBlock.startBlock("Exporting XML Safire");
    this.http.post(this.endpointService.endpointExportNavaidsToSafire,
      navaids,
      this.endpointService.fileHttpOptions
    ).subscribe((blob:Blob)=>{
      fileSaver.saveAs(blob,"navaidsSafire.xml");
      this.uiBlock.stopBlock();
    },
    (error)=>{
      this.uiBlock.stopBlock();
    }
    );
  }
}
